import mergeOperations from "@/util/shallowMerge"
import {
  useMutation 
} from "@apollo/client"
import {
  useCallback, useMemo, useRef, useState 
} from "react"
import DEFAULT_OPERATIONS from "./warrantyPage.gql"

export const useWarrantyPage = (props) => {
  const {
    afterSubmit 
  } = props

  const operations = mergeOperations(DEFAULT_OPERATIONS, props.operations)

  const {
    addWarrantyInfoMutation 
  } = operations

  const formApiRef = useRef(null)

  const [isLoading, setIsLoading] = useState(false)

  const [addWarrantyInfo, {
    data, error: addWarrantyError 
  }] = useMutation(
    addWarrantyInfoMutation,
    {
      fetchPolicy: "no-cache",
    }
  )

  const setFormApi = useCallback((api) => (formApiRef.current = api), [])

  const handleSubmit = useCallback(
    async (formValues) => {
      setIsLoading(true)

      try {
        await addWarrantyInfo({
          variables: formValues,
        })

        if (afterSubmit) {
          afterSubmit()
        }
      } catch (error) {
        console.error(error)

        if (process.env.NODE_ENV !== "production") {
          console.error(error)
        }
      } finally {
        setIsLoading(false)
      }
    },
    [addWarrantyInfo, afterSubmit]
  )

  const errors = useMemo(() => {
    if (addWarrantyError) {
      return [addWarrantyError]
    } else if (data?.addWarrantyInfo?.code === "500") {
      return [new Error(data.addWarrantyInfo.content)]
    }
 
    return []
        
  }, [data, addWarrantyError])

  return {
    setFormApi,
    isLoading,
    formErrors: errors,
    handleSubmit,
    response: data && data.addWarrantyInfo,
  }
}
